var _require = require('../overlay.shell'),
  buildRustscriptOverlay = _require.buildRustscriptOverlay;
module.exports = function (options) {
  var title = options.title,
    value = options.value,
    placeholder = options.placeholder;
  var safeValue = String(value !== null && value !== void 0 ? value : '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  return buildRustscriptOverlay({
    className: 'rs-overlay-prompt rs-prompt-number-panel',
    title: title,
    bodyHtml: "\n      <input\n        type=\"text\"\n        inputmode=\"numeric\"\n        pattern=\"[0-9]*\"\n        class=\"saito-input rs-prompt-value rs-prompt-number-input\"\n        value=\"".concat(safeValue, "\"\n        placeholder=\"").concat(placeholder, "\"\n        autocomplete=\"off\"\n        spellcheck=\"false\"\n      />\n      <p class=\"rs-prompt-validation\" hidden></p>\n    "),
    actionsHtml: "<button type=\"button\" class=\"rs-btn rs-btn-primary rs-prompt-apply\">Apply</button>"
  });
};